import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SidebarAdmin from "./sidebar-admin";
import { API_URL } from "../config";

interface Trip {
    id: number;
    title: string;
    date_trip: string;
    country: string;
    location: string;
    price: string;
  }
  
interface BookingTour {
    id: number;
    date_booking: string;
    email: string;
    firstname: string;
    lastname: string;
    phone: string;
    trip_id: number;
    status: string;
    trip?: Trip;
}
  

const DetailsBookingTour = () =>{
    
    const { id } = useParams<{ id: string }>();
    const [bookingTour, setBookingTour] = useState<BookingTour | null>(null);

    const fetchBookingTourDetails = async () => {
        try {
          
          const response = await axios.get(`${API_URL}/booking-trip/${id}`);
          console.log("responsee", response.data);
          setBookingTour(response.data.data);
        } catch (error) {
          console.error("Error loading details:", error);
        }
    };

    //

    useEffect(() => {
        if (id) {
            fetchBookingTourDetails();
        }
      }, [id]);

      const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
      };

      const getStatusBadge = (status: string) => {
        const statusConfig: Record<string, { class: string; text: string }> = {
          confirmed: { class: "bg-success", text: "Confirmed" },
          cancelled: { class: "bg-danger", text: "Cancelled" }
        };
    
        const config = statusConfig[status] || { 
          class: "bg-secondary", 
          text: status 
        };
        
        return (
          <span className={`badge ${config.class} text-white px-3 py-2`}>
            {config.text}
          </span>
        );
      };

      return(
        <>
        
        <div className="dashboard-layout">
        <aside className="dashboard-sidebar">
          <SidebarAdmin />
        </aside>

        <div className="dashboard-main">
          <header className="dashboard-header">
            <div className="header-content">
              <button className="menu-toggle">
                <i className="icon-menu-2 text-20"></i>
              </button>
            </div>
          </header>

          <main className="dashboard-content">
            <div className="dashboard__content bg-light-2">
              <div className="row y-gap-20 justify-between items-end pb-10 lg:pb-40 md:pb-32">
                <div className="col-auto">
                  <h1 className="text-24 fw-600">Details booking trip: {bookingTour?.trip?.title }</h1>
                </div>
                <div className="col-auto">
                  <div className="d-flex gap-2 align-items-center">
                  {bookingTour && getStatusBadge(bookingTour.status)}
                    <button 
                      className="btn btn-outline-secondary btn-sm"
                      onClick={() => window.history.back()}
                    >
                      ← Back
                    </button>
                  </div>
                </div>
              </div>

              <div className="row">
                {/* Customer Information */}
                <div className="col-md-6 mb-4">
                  <div className="py-30 px-30 rounded-4 bg-white shadow-3 h-100">
                    <h4 className="text-18 fw-600 mb-4">Customer Information</h4>
                    <div className="row">
                      <div className="col-12 mb-3">
                        <label className="text-14 text-muted">Name</label>
                        <p className="text-16 fw-500">
                           {bookingTour?.firstname} {bookingTour?.lastname}
                        </p>
                      </div>
                      <div className="col-12 mb-3">
                        <label className="text-14 text-muted">Email</label>
                        <p className="text-16">
                           {bookingTour?.email}
                        </p>
                      </div>
                      <div className="col-12 mb-3">
                        <label className="text-14 text-muted">Phone</label>
                        <p className="text-16">
                           {bookingTour?.phone}
                        </p>
                      </div>
               
                    </div>
                  </div>
                </div>

                
                <div className="col-md-6 mb-4">
                  <div className="py-30 px-30 rounded-4 bg-white shadow-3 h-100">
                    <h4 className="text-18 fw-600 mb-4">Booking Information</h4>
                    <div className="row">
                      <div className="col-12 mb-3">
                        <label className="text-14 text-muted">Booking Date</label>
                        <p className="text-16 fw-500">
                          {bookingTour && formatDate(bookingTour?.date_booking)}
                        </p>
                      </div>

                      <div className="col-12 mb-3">
                        <label className="text-14 text-muted">Status</label>
                        <p className="text-16 fw-500">
                        {bookingTour && getStatusBadge(bookingTour.status)}
                        </p>
                      </div>

             
                    </div>
                  </div>
                </div>

    
                <div className="col-12 mb-3">
                  <div className="py-30 px-30 rounded-4 bg-white shadow-3">
                    <h4 className="text-18 fw-600 mb-4">Tour Information</h4>
                    <div className="row">
                      <div className="col-md-3 mb-3">
                        <label className="text-14 text-muted">Title</label>
                        <p className="text-16 fw-500">
                           {bookingTour &&  bookingTour.trip && bookingTour.trip.title}
                        </p>
                      </div>
                      <div className="col-md-3 mb-3">
                        <label className="text-14 text-muted">Date trip</label>
                        <p className="text-16">
                         {bookingTour &&  bookingTour.trip && bookingTour.trip.date_trip}
                        
                        </p>
                      </div>
                      <div className="col-md-3 mb-3">
                        <label className="text-14 text-muted">Country</label>
                        <p className="text-16">
                        {bookingTour &&  bookingTour.trip && bookingTour.trip.country}
                        </p>
                      </div>

                      <div className="col-md-3 mb-3">
                        <label className="text-14 text-muted">Location</label>
                        <p className="text-16">
                        {bookingTour &&  bookingTour.trip && bookingTour.trip.location}
                        </p>
                      </div>
               
           
               
                    </div>

                    {/* Reference Prices */}
                    <div className="row mt-4">
                      <div className="col-12">
                        <h5 className="text-16 fw-600 mb-3">Reference Prices</h5>
                        <div className="row">
                          <div className="col-md-4 mb-2">
                            <label className="text-14 text-muted">Price</label>
                            <p className="text-16 fw-500">
                            {bookingTour &&  bookingTour.trip && bookingTour.trip.price}
                            </p>
                          </div>
                  
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

 

              </div>
            </div>
          </main>
        </div>
      </div>
        </>
      )

}
export default DetailsBookingTour;